import { find, isEmpty, isNil, set } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import * as layerOps from '../../api/Layers/layer-operations';
import { styleFetchOne } from '../../api/Styles/style-methods-client';
import buildGeoJSONDataSource from './buildGeoJSONDataSource';
import buildTileServerLayer from './buildTileServerLayer';
import buildTMSLayer from './buildTMSLayer';
import buildWMSLayer from './buildWMSLayer';
import buildWMTSLayer from './buildWMTSLayer';
import getDefaultStyle from '../get-default-style';
import build3DTileset from './build3DTileset';

const ERROR_MESSAGE = 'No está disponible para este tipo de layer';

/**
 * Adds the selected layer to the map.
 *
 * @async
 * @param {object} arg - The object argument.
 * @param {object} arg.cesiumViewer - The cesium viewer object.
 * @param {boolean} arg.isAdded - Flag to determine if the layer will be added to the viewer.
 * @param {object} arg.layer - The layer to draw in the viewer.
 * @param {object[]} arg.layersTransparency - An array containing the layers that need a different transparency value.
 */
const addLayerToCesiumViewer = async ({ cesiumViewer, isAdded, layer, layersTransparency }) => {
  let transparency;
  const layerTransparency = find(layersTransparency, ['id', layerOps.getId(layer)]);
  if (!isNil(layerTransparency)) transparency = layerTransparency.value;

  try {
    let newLayer = '';
    const style = !isEmpty(layer.styleValue)
      ? layer.styleValue
      : (await styleFetchOne(layerOps.getStyleId(layer))) || getDefaultStyle(layer);

    switch (true) {
      case layerOps.isTileServer(layer):
        newLayer = buildTileServerLayer(layer, transparency);
        break;
      case layerOps.is3DTile(layer):
        newLayer = build3DTileset(layer);
        break;
      case layerOps.isTMS(layer):
        newLayer = buildTMSLayer(layer, transparency);
        break;
      case layerOps.isWMS(layer):
        newLayer = buildWMSLayer(layer, transparency);
        break;
      case layerOps.isWMTS(layer):
        newLayer = buildWMTSLayer(layer, transparency);
        break;
      case layerOps.isGeoJSONApiBased(layer):
        if (!isNil(transparency)) set(style, ['geojsonStyle', 'styleData', 'alpha'], transparency);
        newLayer = await buildGeoJSONDataSource({ layer, style });
        break;
      default:
        Bert.alert('Wrong Layer data', 'danger');
        break;
    }

    newLayer.ipsilumId = layerOps.getId(layer);
    newLayer.show = isAdded;
    if (layerOps.isGeoJSONApiBased(layer)) cesiumViewer.dataSources.add(newLayer);
    if (layerOps.is3DTile(layer)) cesiumViewer.scene.primitives.add(newLayer);

    return newLayer;
  } catch (error) {
    throw new Error(`${ERROR_MESSAGE} ${layerOps.getName(layer)}`);
  }
};

export default addLayerToCesiumViewer;
